import React from 'react';
import validator from 'validator';
import { useNavigate } from "react-router-dom";
import EdInput from './../../components/edInput';
import EdButton from './../../components/edButton';
import EdHelmet from '../../components/edHelmet';


const PageSignIn = () => {
    const [errors, setErrors] = React.useState({});
    const [values, setValues] = React.useState({});
    const navigate = useNavigate();
    const _DEFAULT_EMAIL_AND_PASSWORD = "demo@edplato.com"

    const handleChange = (e) => {
        const { name, value, label } = e.target;
        if (!e || !e.target || values[name] === value) return;

        // Update current values
        values[name] = value;
        if (label) values[name + "Label"] = label;
        setValues({ ...values });

        // Update errors
        checkValidation();
    }

    const checkValidation = () => {
        let validationErrors = {};

        // isEmail
        if (!values.email)
            validationErrors.email = "Email is required";
        else if (!validator.isEmail(values.email))
            validationErrors.email = "Email is not valid";

        // isLength
        if (!values.password)
            validationErrors.password = "Password is required";
        else if (!validator.isLength(values.password, { min: 4 }))
            validationErrors.password = "Password must be at least 4 characters";

        // check validationErrors
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return false;
        }
        else {
            setErrors({});
            return true;
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (checkValidation() === false) return;

        // Check if email and password are correct
        if (values.email !== _DEFAULT_EMAIL_AND_PASSWORD || values.password !== _DEFAULT_EMAIL_AND_PASSWORD) {
            setErrors({ submit: true });
        }
        else {
            setErrors({});
            window.localStorage.setItem("token", "demo");
            navigate("/dashboard")
        }
    }

    return <main className="grow py-12">
        <EdHelmet title="Sign In" description="Sign in to access our educational resources and exclusive services. Available for both educators and students." />
        <section className="max-w-sm lg:max-w-md px-3 mx-auto text-center">
            <h1 className="font-bold text-3xl my-3">Sign In to your Account</h1>
            <div>Sign in to access our educational resources and exclusive services. Available for both educators and students. Using <code>{_DEFAULT_EMAIL_AND_PASSWORD}</code> as email and password.</div>
            <form className="text-left mt-8" onSubmit={handleSubmit}>
                <EdInput
                    type="email"
                    name="email"
                    label="Email address"
                    defaultValue={values.email}
                    autoComplete={true}
                    isRequired={true}
                    onChange={handleChange}
                    errors={errors}
                    lang="en"
                />
                <EdInput
                    type="password"
                    name="password"
                    label="Password"
                    autoComplete={false}
                    isRequired={true}
                    onChange={handleChange}
                    errors={errors}
                    lang="en"
                />

                <EdButton color="sky" className="w-full">Sign In</EdButton>
                {(errors.submit === true) &&
                    <div className="text-red-500 text-xs mt-1">
                        <div>Email or password is incorrect.</div>
                        <div>Using {_DEFAULT_EMAIL_AND_PASSWORD} as email and password.</div>
                    </div>
                }
            </form>
        </section>
    </main>
}

export default PageSignIn